import React, { FC, useCallback } from "react";
import { localeStringOptionsUnqTokens } from "../../../../../../../common/constants/common.constants";
import { blockInvalidChar } from "../../../../../../../utilities/helpers";
import MaxButton from "../../../../../../MaxButton/MaxButton";

const DepositFts: FC<{
  selectedAmount: number | string | undefined;
  amount: number | undefined;
  updateDepositAmount: (e) => void;
  wrongDepositAmount: string | undefined;
  maxAvailableDepositAmount: number;
}> = ({
  amount,
  maxAvailableDepositAmount,
  selectedAmount,
  updateDepositAmount,
  wrongDepositAmount,
}) => {
  const getMaxUnqTokensHandler = useCallback(async () => {
    if (!amount) {
      return;
    }
    if (amount && amount > maxAvailableDepositAmount) {
      updateDepositAmount(maxAvailableDepositAmount);
      return;
    }

    updateDepositAmount(amount);
  }, [amount, maxAvailableDepositAmount]);

  return (
    <div className="deposit-staking__amount-input">
      <div className="deposit-staking__amount">
        <div className="deposit-staking__amount-with-error">
          <input
            type="number"
            placeholder="Enter the amount of tokens here"
            min="0"
            step={".000001"}
            defaultValue={""}
            value={selectedAmount}
            onKeyDown={blockInvalidChar}
            disabled={amount === undefined}
            onChange={(e) => updateDepositAmount(e.target.value)}
          />
          {wrongDepositAmount && (
            <p className="input__error">{wrongDepositAmount}</p>
          )}
        </div>
        <MaxButton onClick={getMaxUnqTokensHandler} />
      </div>
      {amount !== undefined && (
        <p className="deposit-staking__available-amount">
          Available{" "}
          <span>
            {amount > maxAvailableDepositAmount
              ? maxAvailableDepositAmount.toLocaleString(
                  undefined,
                  localeStringOptionsUnqTokens
                )
              : amount.toLocaleString(undefined, localeStringOptionsUnqTokens)}
          </span>{" "}
          out of{" "}
          <span>
            {maxAvailableDepositAmount.toLocaleString(
              undefined,
              localeStringOptionsUnqTokens
            )}
          </span>{" "}
          UNQ
        </p>
      )}
    </div>
  );
};

export default DepositFts;
